import React from 'react'
import AppNotificationsLayout from './AppNotificationsLayout'

const AppNotifications = () => {
  return <AppNotificationsLayout />
}

export default AppNotifications
